import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncInfoPage = Load(
  () => import(/* webpackChunkName: "info-pages" */ './components/InfoPage'),
  {},
  true,
);

const InfoPagesRoutes = [
  <NavigationableLayout
    key="prismic"
    path={`${basePath}/info/:uid/`}
    component={AsyncInfoPage}
  />,
];

export default InfoPagesRoutes;
